import { IApplicationState } from '../../../types/redux';
import { ITopThreeItem } from '../../../types/top_three';

export const selectTop3 = (state: IApplicationState): ITopThreeItem[] => {
  return state.mainpage.top3 || [];
};
